import React from 'react';

interface BulkFieldRowProps {
  icon?: React.ReactNode;
  label: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export function BulkFieldRow({ icon, label, children, footer }: BulkFieldRowProps) {
  return (
    <div>
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-4">
        <div className="flex items-center gap-2 md:w-44 lg:w-52 md:shrink-0">
          {icon}
          <span className="text-sm font-medium text-gray-900 md:text-gray-700">{label}</span>
        </div>
        <div className="flex w-full min-w-0 flex-1 items-center gap-2 sm:gap-3">{children}</div>
      </div>
      {footer}
    </div>
  );
}

interface BulkApplyButtonProps {
  disabled?: boolean;
  onClick: () => void;
  children?: React.ReactNode;
}

export function BulkApplyButton({
  disabled = false,
  onClick,
  children = '変更'
}: BulkApplyButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`h-[30px] shrink-0 px-3 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
        !disabled
          ? 'bg-blue-600 text-white hover:bg-blue-700'
          : 'bg-gray-100 text-gray-400 cursor-not-allowed'
      }`}
    >
      {children}
    </button>
  );
}

export const bulkInputClass =
  'h-[30px] min-w-0 flex-1 rounded-md border border-gray-300 bg-gray-50 px-3 text-sm md:flex-none';

export const bulkSelectClass =
  'h-[30px] min-w-0 flex-1 rounded-md border border-gray-300 bg-gray-50 text-sm md:w-48 md:flex-none';
